module.exports = __webpack_public_path__ + "media/images/cliparts/Rocket Up-bc4f622fb8597e3bd4de1b45560273f1.svg";